import script from "./MainForgotPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainForgotPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainForgotPasswordComponent.vue?vue&type=style&index=0&id=b09f0696&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b09f0696"]])

export default __exports__